import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { DocumentType } from '@synergy/models';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Activity } from '../models/activity';
import { ActivityComment } from '../models/activity-comment';
import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';

export const ACTIVITIES_RECEIVED = 'ACTIVITIES_RECEIVED';
export const ACTIVITIES_RESET = 'ACTIVITIES_RESET';
export const ACTIVITIES_COMMENT_ADDED = 'ACTIVITIES_COMMENT_ADDED';
export const ACTIVITIES_COMMENT_UPDATED = 'ACTIVITIES_COMMENT_UPDATED';
export const ACTIVITIES_COMMENT_DELETED = 'ACTIVITIES_COMMENT_DELETED';

export const SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE';
export const RESET_DOCUMENT_TYPE = 'RESET_DOCUMENT_TYPE';

export const activitiesReceived = (activities: Activity[]) => {
    return {
        type: ACTIVITIES_RECEIVED,
        activities,
    };
};

export const resetActivities = () => {
    return {
        type: ACTIVITIES_RESET,
    };
};

export const activityCommentAdded = (activityId: number, comment: ActivityComment) => {
    return {
        type: ACTIVITIES_COMMENT_ADDED,
        activityId,
        comment,
    };
};

export const activityCommentUpdated = (activityId: number, comment: ActivityComment) => {
    return {
        type: ACTIVITIES_COMMENT_UPDATED,
        activityId,
        comment,
    };
};

export const activityCommentDeleted = (activityId: number, commentId: number) => {
    return {
        type: ACTIVITIES_COMMENT_DELETED,
        activityId,
        commentId,
    };
};

export const fetchActivities = (documentType: DocumentType, documentId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.activities.getActivities(documentType, documentId);

        if (response.success) {
            dispatch(activitiesReceived(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const addComment = (activityId: number, comment: string) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const documentType = getState().activities.documentType;
        if (documentType === undefined) {
            return;
        }

        const response = await api.activities.addComment(activityId, comment, documentType);

        if (response.success && response.result) {
            dispatch(activityCommentAdded(activityId, response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateComment = (activityId: number, commentId: number, comment: string) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const documentType = getState().activities.documentType;
        if (documentType === undefined) {
            return;
        }

        const response = await api.activities.updateComment(activityId, commentId, comment, documentType);

        if (response.success && response.result) {
            dispatch(activityCommentUpdated(activityId, response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteComment = (activityId: number, commentId: number) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const documentType = getState().activities.documentType;
        if (documentType === undefined) {
            return;
        }

        const response = await api.activities.deleteComment(activityId, commentId, documentType);

        if (response.success && response.result) {
            dispatch(activityCommentDeleted(activityId, commentId));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const setDocumentType = (documentType: DocumentType) => {
    return {
        type: SET_DOCUMENT_TYPE,
        documentType,
    };
};

export const resetDocumentType = () => {
    return {
        type: RESET_DOCUMENT_TYPE,
    };
};
